import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.reconnectBankAccount.SuccessPage', {
    title: 'Connect Bank Account | Success',
    connectionEstablished: 'Connection is established',
    pleaseProceed: 'Your banking connection is now established.',
    youLlBeRedirected: 'You will be automatically redirected to bank accounts page in a few seconds.',
    learnMore: 'Learn more',
    viewBankAccounts: 'View bank accounts',
});
